module.exports = __webpack_public_path__ + "static/media/i-open-in-new.1e56c920.svg";